import { IVideoPageTrackingData } from "./utils.types";

export const videoPageTrackingData = ({
  videoData,
  searchQuery,
  videoSearchIndex,
  utm_source,
  utm_medium,
  sharedBy,
  recommended,
  rank
}: IVideoPageTrackingData) => ({
  incomingSource: "website",
  ...(searchQuery && { searchQuery }),
  questionId: videoData.questionId,
  questionText: videoData.title,
  subject: [videoData.subjects[0]],
  questionSection: videoData.sections,
  questionChapter: videoData.chapters,
  questionTopic: videoData.topics,
  grade: [videoData.grades[0]],
  ...(videoSearchIndex && { videoSearchIndex }),
  ...(utm_source && { utm_source }),
  ...(utm_medium && { utm_medium }),
  ...(sharedBy && { sharedBy }),
  isShared: sharedBy ? true : false,
  tanyaRecommendedVideo: recommended || "false",
  ...(rank && { recommendedVideoRank: rank })
});
